/**
 * `/` slash command — opens the shared ContentBlocksMenu when `/` is typed on an
 * otherwise-empty line. Selecting an item clears the slash and inserts the chosen
 * block via the shared `insertContentBlock` helper, so the slash menu and the
 * "Add content" button behave identically.
 *
 * State, trigger detection, and block insertion all live in SlashCommandStore so
 * this file only renders the popover.
 */

import { realmPlugin, addComposerChild$, useCellValue, readOnly$, insertMarkdown$, usePublisher } from '@mdxeditor/editor'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import { useMarkdownStore } from '../../MarkdownStore'
import ContentBlocksMenu from '../../popover/ContentBlocksMenu'
import SlashCommandStore from './SlashCommandStore'

const SlashCommandComponent = observer(function SlashCommandComponent() {
   const [editor] = useLexicalComposerContext()
   const isReadOnly = useCellValue(readOnly$)
   const insertMarkdown = usePublisher(insertMarkdown$)
   const markdownStore = useMarkdownStore()

   const slashCommandStore = useStore(sp => new SlashCommandStore(sp), { editor, markdownStore, insertMarkdown })

   if (isReadOnly || !slashCommandStore.open) return null

   return <ContentBlocksMenu
      anchor={slashCommandStore.open.anchor}
      query={slashCommandStore.open.query}
      onSelect={slashCommandStore.handleItemSelect}
      onClose={slashCommandStore.close}
   />
})

export const slashCommandPlugin = realmPlugin({
   init(realm) {
      realm.pub(addComposerChild$, SlashCommandComponent)
   },
})
